//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import competitionApi from '@/api/competition'
export default {
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    FormData: {
      type: Object,
      default() {
        return {}
      },
    },
    TeamMember: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return {
      showMask: true,
      serverList: [],
      memberList: [],
      // 图片baseurl
      imgUrl: 'https://img.b5csgo.com.cn/',
    }
  },
  computed: {
    isSuccess() {
      return !this.showMask
    },
    routeId() {
      return this.$route.params.id
    },
  },
  filters: {
    formatDan(val, rank) {
      if (rank === -1 || rank === 0) {
        return '无限制'
      } else {
        return `${val}及以上`
      }
    },
  },
  methods: {
    closeForm() {
      if (this.showMask) {
        this.$emit('change-show-form', 0)
      }
    },
    async sendApplication() {
      // if (this.serverList.length > 0) {
      //   regionIds = this.serverList
      //     .reduce((a, b) => {
      //       return a + b.serverId + ','
      //     }, '')
      //     .slice(0, -1)
      // } else {
      //   this.$message({
      //     message: '请选择倾向服务器',
      //     customClass: 'copy-message',
      //     center: true,
      //     duration: 1000,
      //     offset: 340,
      //   })
      //   return
      // }
      let res = await competitionApi.joinEvent(
        this.memberList,
        +this.routeId
      )
      if (res.code === 0) {
        this.showMask = false
      } else {
        this.$message({
          message: res.msg,
          customClass: 'copy-message',
          center: true,
          duration: 1000,
          offset: 340,
        })
      }
    },
    closeDialog() {
      this.$emit('change-show-form', 1)
    },
  },
}
